export default {
  wiki: 'http://wiki.anchor-webapps.com/doku.php',
  serviceDesk: 'https://anchorloans.atlassian.net/servicedesk/customer/portal/1',
};
